var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { default as UiButton } from "@atlaskit/button";
import Loading from "../Loading";
import styled from "styled-components";
export default (function (props) {
    var children = props.children, appearance = props.appearance, isLoading = props.isLoading, isDisabled = props.isDisabled, rest = __rest(props, ["children", "appearance", "isLoading", "isDisabled"]);
    var newAppearance = appearance
        ? appearance
        : "primary";
    // @ts-ignore
    if (newAppearance === "secondary") {
        newAppearance = "subtle";
    }
    return (_jsx(UiButton, __assign({}, rest, { appearance: newAppearance, isDisabled: isLoading || isDisabled, style: { height: 36, lineHeight: "36px" } }, { children: isLoading ? (_jsxs(StyledLoadingButton, { children: [_jsx(StyledLoading, { children: _jsx(Loading, { size: 15 }) }), _jsx(StyledChildren, { children: children })] })) : (children) })));
});
var StyledLoadingButton = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var StyledLoading = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  display: block;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"], ["\n  position: absolute;\n  display: block;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"])));
var StyledChildren = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  opacity: 0;\n"], ["\n  opacity: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map